import { Typography } from '@mui/material';
import { isEmpty } from 'lodash-es';
import React, { FC } from 'react';

import { Loader } from '@sbu/components.loader';

import { JsonTree } from 'shared/components/data/Tree';

import css from './SumoRawMessage.module.scss';

interface SumoRawMessageProps {
  loading: boolean;
  rawMessage: any;
}

export const SumoRawMessage: FC<
  React.PropsWithChildren<SumoRawMessageProps>
> = ({ loading, rawMessage }) => {
  let jsonData = {};
  try {
    jsonData = JSON.parse(rawMessage);
  } catch (e) {
    // no-op
  }

  return loading ? (
    <Loader minHeight={78} size='xlarge' />
  ) : !isEmpty(jsonData) ? (
    <JsonTree data={jsonData} />
  ) : (
    <Typography variant='code' className={css.rawMessage}>
      {rawMessage}
    </Typography>
  );
};
